var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('div',{staticClass:"container title-area"},[_c('div',{staticClass:"columns is-centered"},[_c('div',{staticClass:"column is-full intro-message"},[_c('h3',{staticClass:"is-size-5 has-text-weight-medium has-text-black-ter start-title",domProps:{"innerHTML":_vm._s(this.$store.getters.getInfo.before_start_message)}})])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3c327808","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/elements/intro/BeforeStart.vue
// module id = null
// module chunks = 